(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v3"] && !Shopify.designMode) return;
  try {
    
      let navegador = navigator.userAgent;
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
          //const mother = document.getElementById("0507daf7-2dea-4c05-878f-e9e67e4fc91e");
          //const mother_botton = document.getElementById("0507daf7-2dea-4c05-878f-e9e67e4fc91e-b");
          const slider_valentine = document.getElementById("slideshow_Kcp9GL");
          const valentine_botton = document.getElementById("slideshow_Kcp9GL-b");
          //const slider_two = document.getElementById("1581499093418-1");
          //const slider_tree = document.getElementById("1581499093418-0");
          //const slider_four = document.getElementById("1581499093418-2");
          //const slider_tree_text = document.getElementById("1581499093418-0-1");
          
          //mother.setAttribute("src", "https://cdn.shopify.com/s/files/1/0570/0973/3783/files/slider-11.png?v=1714332216");
          slider_valentine.setAttribute("src", "https://cdn.shopify.com/s/files/1/0570/0973/3783/files/Slider_Palato_Valentine_Movil.jpg?v=1738979819");
          //slider_two.setAttribute("src", "https://cdn.shopify.com/s/files/1/0570/0973/3783/files/slider-14.png?v=1714281777");
          //slider_tree.setAttribute("src", "https://cdn.shopify.com/s/files/1/0570/0973/3783/files/slider-12.gif?v=1714279951");
          //slider_tree_text.textContent = "";
          //slider_four.setAttribute("src", "https://cdn.shopify.com/s/files/1/0570/0973/3783/files/Slider-13.png?v=1714281327");
          //mother_botton.setAttribute("style", "margin-top:263px; color:#ffff; border-color:#FCBCC4; background:#503629;");
          valentine_botton.setAttribute("style", " color:#ffff; border-color:#FCBCC4; background:#503629;");
        }


  } catch(e) { console.error(e); }
})();
})();
